import LoadingOverview from './../../views/loading/LoadingOverview';
import CargoOrders from './../../views/loading/CargoOrders';
import ProductsOverview from '../../views/teamlead/ProductsOverview';
import OutgoingCargoOverview from '../../views/teamlead/OutgoingCargoOverview';
import manualPickLocationAdjustment from './../../views/teamlead/manualPickLocationAdjustment';
import manualOrderProductAdjustment from './../../views/teamlead/manualOrderProductAdjustment';
import orderHandling from "../../views/teamlead/orderHandling";
import DockSuggestions from "@/views/teamlead/DockSuggestions";
import deviations from "../../views/teamlead/Deviations";
import MissingGoods from "@/views/teamlead/MissingGoods";
import orderHandlingTvat from "@/views/teamlead/orderHandlingTvat";

const loadingRoutes = [
  {path: '/loading', name: 'loading', component: LoadingOverview},
  {path: '/loading/cargo/:id', name: 'loading-cargo-orders', component: CargoOrders},
  // {path: '/loading/admin', component: Teamlead, meta: {hasAcces: ['teamlead']}},
  {
    path: '/loading/admin/products',
    name: 'teamlead-products-overview',
    component: ProductsOverview
    // meta: {hasAcces: ['teamlead']}
  },
  {
    path: '/unloading/admin/docksuggestions',
    name: 'teamlead-dock-suggestions-loading',
    component: DockSuggestions,
    meta: { view: 'loading' }
  },
  {
    path: '/loading/admin/orderhandling',
    name: 'teamlead-order-handling-loading',
    component: orderHandling,
    meta: { view: 'loading' }
  },
  {
    path: '/loading/admin/cargohandling',
    name: 'teamlead-cargo-handling-loading',
    component: orderHandlingTvat,
    meta: { view: 'loading' }
  },
  {
    path: '/loading/admin/deviations',
    name: 'teamlead-deviations-loading',
    component: deviations
  },
  {
    path: '/loading/admin/outgoingCargos',
    name: 'teamlead-cargo-loading-overview',
    component: OutgoingCargoOverview
    // meta: {hasAcces: ['teamlead']}
  },
  {
    path: '/teamlead/missing-goods',
    name: 'teamlead-missing-goods',
    component: MissingGoods
    // meta: {hasAcces: ['teamlead']}
  },
  {
    path: '/loading/manual',
    name: 'loading-manual-pick-location-change',
    component: manualPickLocationAdjustment,
    props: true
  },
  {
    path: '/loading/manualOrderProduct',
    name: 'loading-manual-order-product-change',
    component: manualOrderProductAdjustment,
    props: true
  }

];
export default loadingRoutes;

